import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=50670b66&scoped=true"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"
import style0 from "./EventCategory.vue?vue&type=style&index=0&id=50670b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50670b66",
  null
  
)

export default component.exports